<template>
  <div>
    <DxDropDownButton
      :items="getItems"
      :keyExpr="'ScreenLayoutApplicationFeatureCode'"
      :displayExpr="'ReportDisplayName'"
      :drop-down-options="{ width: 200 }"
      class="gc-dropdown-icon-button"
      :icon="'message'"
      styling-mode="text"
      :show-arrow-icon="false"
      :onItemClick="onItemClick"
      v-if="getItems.length > 1"
    />
    <DxButton
      class="invoice-print-btn"
      icon="message"
      @click="onItemClick({ itemData: getItems[0] })"
      v-else
    />

    <GcPopup
      :popup-visible="popupVisible"
      :popup-title="'Warning'"
      :back-button-function="popupBackButtonClick"
      :popupHeight="250"
    >
      <span v-html="errorMsg"></span> <br />

      <p>
        <span>
          Please <a @click="onClickToAddContact">click here</a> to configure
          email settings.
        </span>
      </p>
    </GcPopup>

    <GcPopupInteractiveEmail
      :visible.sync="getVisibleEmailPopup"
      :showLoading="showLoading"
      :emailModel="emailModel"
      :invoice-number="''"
      ref="gc-popup-interactive-email"
      @send-email-success="sendEmailSuccess"
      v-if="getVisibleEmailPopup"
    />
  </div>
</template>
<script>
import { InteractiveEmailService } from "../_services/api/customers/interactive-email.service";
import GcPopupInteractiveEmail from "../popups/data-grid/gc-popup-interactive-email.vue";

export default {
  components: { GcPopupInteractiveEmail },
  props: {
    data: {
      type: [Object, Array],
      default: () => {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    dataField: {
      type: String,
      default: "Code",
    },
    refresh: {
      type: Function,
      default: () => {},
    },
    dataModel: {
      type: [Object, Array],
      default: () => {},
    },
    menuItems: {
      type: Object,
      default: () => {},
    },
    baseView: {
      type: Object,
    },
  },
  data() {
    return {
      printReports: undefined,
      validationSummaryVisible: false,
      validationItems: [],
      popupVisible: false,
      errorMsg: undefined,
      errorData: undefined,

      visibleEmailPopup: false,
      emailModel: undefined,
    };
  },

  computed: {
    getItems() {
      if (this.data)
        if (this.data.menuItems)
          if (this.data.menuItems.makeDisabled)
            return this.data.menuItems.makeDisabled(this.dataModel, this.data);
          else return this.data;
        else return this.data;
      else return [];
    },

    /*
     * Computed property to get and set the visibility of the popup
     */
    getVisibleEmailPopup: {
      get() {
        return this.visibleEmailPopup;
      },
      set(value) {
        this.visibleEmailPopup = value;
      },
    },

    getReferenceField() {
      const itemData = this.emailModel.itemData;
      var referenceNoField = undefined;
      if (this.menuItems.referenceNoField) {
        referenceNoField = this.menuItems.referenceNoField;
      } else if (this.menuItems.referenceNoFields) {
        this.menuItems.referenceNoFields.forEach((element) => {
          if (element.ReportDisplayName == itemData.ReportDisplayName) {
            referenceNoField = element.ReferenceNoField;
          }
        });
      }

      // ReferenceNo should be a String
      return "" + this.dataModel[referenceNoField];
    },
  },
  methods: {
    onClickToAddContact() {
      this.popupBackButtonClick();

      let baseUrl = process.env.VUE_APP_BASE_URL;
      let url = "";

      if (this.errorData.ContactType == "Customer") {
        if (baseUrl === "/")
          url = `${baseUrl}customer-contact/${this.errorData.PartnerCode}`;
        else url = `/customer-contact/${this.errorData.PartnerCode}`;
      } else if (this.errorData.ContactType == "Supplier") {
        if (baseUrl === "/")
          url = `${baseUrl}supplier-contact/${this.errorData.PartnerCode}`;
        else url = `/supplier-contact/${this.errorData.PartnerCode}`;
      }

      var route = this.$router.resolve({ path: url });
      window.open(route.href, "_blank");
    },
    popupBackButtonClick() {
      this.popupVisible = false;
    },
    async onItemClick(data) {
      this.showLoading(true);
      this.emailModel = { itemData: data.itemData };
      if (data.itemData.ScreenLayoutApplicationFeatureCode) {
        let referenceNo = this.getReferenceField;
        try {
          const response =
            await InteractiveEmailService.getInteractiveEmailModal(
              data.itemData.ScreenName,
              data.itemData.ReportDisplayName,
              data.itemData.TransactionCode,
              referenceNo,
            );
          if (response && response.data) {
            this.emailModel = { ...response.data, itemData: data.itemData };
          } else {
            this.emailModel = { itemData: data.itemData };
          }
        } catch (error) {
          this.$store.dispatch("ui/setServerError", {
            error: error,
            title: "Failed",
          });
        } finally {
          this.visibleEmailPopup = true;
          this.showLoading(false);
        }
      }
    },

    async sendEmailSuccess(payloadHelper) {
      const itemData = this.emailModel.itemData;

      let payload = {
        ReportName: itemData.ReportDisplayName,
        ScreenName: itemData.ScreenName,
        TransactionCode: itemData.TransactionCode,
        ReferenceNo: this.getReferenceField,
        ...payloadHelper,
      };

      this.showLoading(true);
      try {
        const response =
          await InteractiveEmailService.SaveInteractiveEmailModal(payload);

        if (response) {
          this.$notify(
            `${itemData.ReportDisplayName} email notification queued successfully`,
            "success",
          );
        }
        this.refresh();
        this.showLoading(false);
        this.visibleEmailPopup = false;
      } catch (error) {
        this.showLoading(false);
        this.$store.dispatch("ui/setServerError", {
          error: error,
          title: "Failed",
        });
      }
    },
  },
};
</script>

<style lang="scss"></style>
